export const roadAndPathLayers = [
  "road-path",
  "road-pedestrian",
  "road-street",
  "road-primary",
  "road-secondary-tertiary",
  "road-minor",
  "road-motorway-trunk",
];
